import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
} from 'store/helpers/filterHelpers';
import { newspaperFiltersInitialState } from './initialState/newspaperInitialState';

export { newspaperFiltersInitialState as filtersInitialState };

export const newspaperSearchResourceInitialState = {
  filters: newspaperFiltersInitialState,
  // sortBy: {
  //   selected: '',
  //   order: 'desc',
  // },
};
export const newspaperSearchResourceSlice = createSlice({
  name: 'newspaperSearchResourceSlice',
  initialState: newspaperSearchResourceInitialState,
  reducers: {
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, newspaperFiltersInitialState);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = newspaperFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, newspaperFiltersInitialState);
    },
  },
});

export const {
  setSelectedFilterValue,
  resetAllFilters,
  toggleCollapsed,
  resetFilter,
} = newspaperSearchResourceSlice.actions;
